var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSearchBlueBg(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 44,
    height: 44,
    viewBox: "0 0 44 44",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 12C0 5.37258 5.37258 0 12 0H32C38.6274 0 44 5.37258 44 12V32C44 38.6274 38.6274 44 32 44H12C5.37258 44 0 38.6274 0 32V12Z",
    fill: "#5062F0"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12 21.1667C12 16.1041 16.1041 12 21.1667 12C26.2293 12 30.3333 16.1041 30.3333 21.1667C30.3333 23.2472 29.6402 25.1659 28.4722 26.7043L31.2173 29.4494C31.7055 29.9376 31.7055 30.7291 31.2173 31.2172C30.7292 31.7054 29.9377 31.7054 29.4495 31.2172L26.7045 28.4721C25.166 29.6402 23.2473 30.3333 21.1667 30.3333C16.1041 30.3333 12 26.2293 12 21.1667ZM21.1667 14.5C17.4848 14.5 14.5 17.4848 14.5 21.1667C14.5 24.8486 17.4848 27.8333 21.1667 27.8333C24.8486 27.8333 27.8333 24.8486 27.8333 21.1667C27.8333 17.4848 24.8486 14.5 21.1667 14.5Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSearchBlueBg);
export default __webpack_public_path__ + "static/media/searchBlueBg.be52711fc4654a898061a6c83ce2ef18.svg";
export { ForwardRef as ReactComponent };